import { render } from "./InputInput.vue?vue&type=template&id=25f44c2f"
import script from "./InputInput.vue?vue&type=script&lang=js"
export * from "./InputInput.vue?vue&type=script&lang=js"

import "./InputInput.vue?vue&type=style&index=0&id=25f44c2f&lang=scss"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__